// extracted by mini-css-extract-plugin
export default {"first90Days__list":"First90Days_first90Days__list__bu5Q+","first90Days__secondlist":"First90Days_first90Days__secondlist__MJKLZ"};